import { useTranslation } from "react-i18next";
import Elips from "../../components/reusable/Elips";
import { FaEnvelope, FaExclamationCircle } from "react-icons/fa";
import "./EmailVerificationModal.css";

export default function EmailVerificationModal({ emailVerificationOpen, emailCode, setEmailCode, verifyEmailCode, verificationError, pendingRegister, email, setVerificationError }) {
    const { t } = useTranslation();
    if (!emailVerificationOpen) return null;

    const handleChange = (event) => {
        setEmailCode(event.target.value.replace(/\D/g, "").slice(0, 6));
        if (verificationError && setVerificationError) setVerificationError("");
    };

    return (
        <div className="otp-overlay" role="dialog" aria-modal="true">
            <div className="otp-modal">
                <div className="otp-icon"><FaEnvelope /></div>
                <span className="otp-kicker">CARRERUP / SÉCURITÉ</span>
                <h2>{t("emailVerification.title")}</h2>
                <p className="otp-subtitle">{t("emailVerification.subtitle")}</p>
                <span className="otp-email">{email}</span>
                <div className={`otp-input-wrap ${verificationError ? "otp-invalid" : ""}`}>
                    <div className="otp-boxes">
                        {[0, 1, 2, 3, 4, 5].map((index) => <div key={index} className={`otp-box ${emailCode[index] ? "filled" : ""}`}>{emailCode[index] || ""}</div>)}
                    </div>
                    <input className="otp-real-input" autoFocus value={emailCode} onChange={handleChange} maxLength={6} inputMode="numeric" aria-label="Code de vérification à six chiffres" />
                </div>
                {verificationError && <div className="otp-error"><FaExclamationCircle /> {verificationError}</div>}
                <button className="otp-btn" disabled={pendingRegister || emailCode.length < 6} onClick={verifyEmailCode}>
                    {pendingRegister ? <Elips /> : t("emailVerification.validate")}
                </button>
            </div>
        </div>
    );
}
